import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

// All 6 loan types — exactly like the screenshot
const LOAN_TYPES = [
  'Business Loan',
  'Personal Loan',
  'Education Loan',
  'Medical Loan',
  'Emergency Loan',
  'Logbook Loan',
];

function ShortcutBanner({ onDismiss }) {
  return (
    <div style={{
      background:'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)',
      borderRadius:'var(--r-lg)', padding:'16px 18px', marginBottom:22,
      display:'flex', alignItems:'flex-start', gap:14, position:'relative',
    }}>
      <div style={{fontSize:26, flexShrink:0}}>📲</div>
      <div style={{flex:1}}>
        <div style={{fontWeight:700, color:'#fff', fontSize:14, marginBottom:4}}>
          Add Lend Pesa to Your Home Screen
        </div>
        <div style={{fontSize:13, color:'rgba(255,255,255,0.70)', lineHeight:1.65, fontWeight:300}}>
          <strong style={{color:'#4ade80'}}>Android:</strong> Tap ⋮ menu → <em>Add to Home Screen</em><br/>
          <strong style={{color:'#4ade80'}}>iPhone:</strong> Tap Share icon → <em>Add to Home Screen</em><br/>
          Access your loans anytime — just like a native app!
        </div>
      </div>
      <button onClick={onDismiss} style={{
        position:'absolute', top:10, right:10,
        background:'rgba(255,255,255,0.12)', border:'none',
        borderRadius:'50%', width:26, height:26, color:'#fff',
        cursor:'pointer', fontSize:16, lineHeight:1,
        display:'flex', alignItems:'center', justifyContent:'center',
      }}>×</button>
    </div>
  );
}

// Loan type dropdown — matches screenshot EXACTLY
// Dark sheet, loan name only, radio circle on right
function LoanTypeDropdown({ value, onChange, error }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function outside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', outside);
    return () => document.removeEventListener('mousedown', outside);
  }, []);

  return (
    <div ref={ref} style={{position:'relative', marginBottom:14}}>

      {/* Trigger — looks like native select */}
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          width:'100%',
          padding:'13px 42px 13px 16px',
          border:`1.5px solid ${error ? '#ef4444' : open ? 'var(--primary)' : 'var(--border-mid)'}`,
          borderRadius:'var(--r-md)',
          background: open ? '#fff' : 'var(--bg-input)',
          fontFamily:'DM Sans, sans-serif',
          fontSize:15,
          color: value ? 'var(--text)' : '#94a3b8',
          cursor:'pointer',
          textAlign:'left',
          transition:'all 0.18s',
          boxShadow: open ? '0 0 0 3px var(--primary-ring)' : 'none',
          fontWeight: value ? 500 : 400,
        }}>
        {value || 'Select Loan Type'}
        <span style={{
          position:'absolute', right:15, top:'50%',
          transform:`translateY(-50%) rotate(${open ? '180' : '0'}deg)`,
          transition:'transform 0.2s',
          color:'#94a3b8', fontSize:12, pointerEvents:'none',
        }}>▼</span>
      </button>

      {/* Dropdown — dark modal sheet matching screenshot exactly */}
      {open && (
        <div style={{
          position:'absolute',
          top:'calc(100% + 8px)',
          left:0, right:0,
          background:'#2e3035',
          borderRadius:20,
          zIndex:9999,
          boxShadow:'0 20px 60px rgba(0,0,0,0.50)',
          overflow:'visible',
          animation:'slideDown 0.18s ease',
        }}>
          {/* Header row — "Select Loan Type" with empty radio */}
          <div style={{
            display:'flex',
            alignItems:'center',
            justifyContent:'space-between',
            padding:'17px 20px',
            borderBottom:'1px solid rgba(255,255,255,0.08)',
          }}>
            <span style={{
              fontSize:17,
              color:'rgba(255,255,255,0.45)',
              fontWeight:400,
              fontFamily:'DM Sans, sans-serif',
            }}>Select Loan Type</span>
            <div style={{
              width:22, height:22, borderRadius:'50%',
              border:'2px solid rgba(255,255,255,0.25)',
            }}/>
          </div>

          {/* Loan type rows — name + radio right, exactly like screenshot */}
          {LOAN_TYPES.map((lt, idx) => {
            const selected = value === lt;
            return (
              <div
                key={lt}
                onClick={() => { onChange(lt); setOpen(false); }}
                style={{
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'space-between',
                  padding:'17px 20px',
                  cursor:'pointer',
                  background: selected ? 'rgba(74,222,128,0.08)' : 'transparent',
                  borderBottom: idx < LOAN_TYPES.length - 1
                    ? '1px solid rgba(255,255,255,0.07)'
                    : 'none',
                  transition:'background 0.14s',
                }}
                onMouseEnter={e => {
                  if (!selected) e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                }}
                onMouseLeave={e => {
                  if (!selected) e.currentTarget.style.background = 'transparent';
                }}
              >
                {/* Loan name — large, clean, exactly like screenshot */}
                <span style={{
                  fontSize:18,
                  fontWeight: selected ? 600 : 400,
                  color: selected ? '#4ade80' : '#ffffff',
                  fontFamily:'DM Sans, sans-serif',
                  letterSpacing:'-0.01em',
                }}>{lt}</span>

                {/* Radio circle on right */}
                <div style={{
                  width:24, height:24, borderRadius:'50%',
                  border: selected ? '2px solid #4ade80' : '2px solid rgba(255,255,255,0.30)',
                  background: selected ? '#4ade80' : 'transparent',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  flexShrink:0,
                  transition:'all 0.15s',
                  boxShadow: selected ? '0 0 0 4px rgba(74,222,128,0.20)' : 'none',
                }}>
                  {selected && (
                    <div style={{
                      width:9, height:9, borderRadius:'50%',
                      background:'#064e3b',
                    }}/>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function Dashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ fullName:'', phone:'', idNumber:'', loanType:'' });
  const [errs, setErrs] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showShortcut, setShowShortcut] = useState(
    !sessionStorage.getItem('shortcut_dismissed')
  );

  const firstName = currentUser?.displayName?.split(' ')[0] || 'there';
  const upd = f => e => setForm(p => ({ ...p, [f]: e.target.value }));

  function validate() {
    const e = {};
    if (!form.fullName.trim()) e.fullName = true;
    if (!form.phone.trim() || form.phone.replace(/\D/g,'').length < 10) e.phone = true;
    if (!form.idNumber.trim()) e.idNumber = true;
    if (!form.loanType) e.loanType = true;
    return e;
  }

  function handleSubmit() {
    const e2 = validate(); setErrs(e2);
    if (Object.keys(e2).length) return;
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
      navigate('/processing', { state: { applicantData: form } });
    }, 2800);
  }

  return (
    <>
      <Navbar />
      <div className="page-shell">
        <div className="page-inner">

          {showShortcut && (
            <ShortcutBanner onDismiss={() => {
              sessionStorage.setItem('shortcut_dismissed','1');
              setShowShortcut(false);
            }} />
          )}

          <div className="quick-actions">
            {[
              { icon:'🧮', label:'Loan Calculator', path:'/calculator' },
              { icon:'📜', label:'My Loans',        path:'/history' },
              { icon:'💬', label:'Support',          path:'/support' },
            ].map(a => (
              <button key={a.path} className="qa-btn" onClick={() => navigate(a.path)}>
                <span className="qa-btn-icon">{a.icon}</span>{a.label}
              </button>
            ))}
          </div>

          <div className="page-eyebrow">👋 Welcome back, {firstName}!</div>
          <h1 className="page-title">Get Your Loan<br />Approved Today</h1>
          <p className="page-sub">Fast approval · No paperwork · Funds in 24 hours</p>

          <div className="form-card" style={{overflow:"visible"}}>
            <div className="form-card-hdr">
              <div className="form-card-hdr-icon">📋</div>
              <div>
                <h3>Personal Information</h3>
                <p>Fill in your details to check eligibility</p>
              </div>
            </div>

            <div className="form-card-body" style={{overflow:"visible"}}>
              <p className="section-tag">YOUR DETAILS</p>

              <input className={`loan-input${errs.fullName?' err':''}`}
                placeholder="Full Name (as on ID)"
                value={form.fullName} onChange={upd('fullName')} />
              {errs.fullName && <p className="inline-err">⚠ Please enter your full name</p>}

              <input className={`loan-input${errs.phone?' err':''}`}
                placeholder="Phone Number (e.g. 0712 345 678)"
                value={form.phone} onChange={upd('phone')} />
              {errs.phone && <p className="inline-err">⚠ Enter a valid Kenyan phone number</p>}

              <input className={`loan-input${errs.idNumber?' err':''}`}
                placeholder="National ID Number"
                value={form.idNumber} onChange={upd('idNumber')} />
              {errs.idNumber && <p className="inline-err">⚠ Please enter your ID number</p>}

              <LoanTypeDropdown
                value={form.loanType}
                onChange={v => setForm(p => ({ ...p, loanType: v }))}
                error={errs.loanType}
              />
              {errs.loanType && <p className="inline-err" style={{marginTop:-10}}>⚠ Please select a loan type</p>}

              <div className="trust-row">
                {[['🔒','Secure'],['✅','CBK Licensed'],['🛡️','No CRB Check']].map(([icon,label]) => (
                  <div className="trust-item" key={label}>
                    <div className="trust-item-icon">{icon}</div>
                    <span>{label}</span>
                  </div>
                ))}
              </div>

              <button className="btn-cta" onClick={handleSubmit}>
                Check My Eligibility →
              </button>
              <p className="no-paper">No paperwork required. No guarantors needed.</p>
            </div>
          </div>

          <div className="page-footer-links">
            <span onClick={() => navigate('/terms')}>Terms</span> ·
            <span onClick={() => navigate('/privacy')}>Privacy</span> ·
            <span onClick={() => navigate('/calculator')}>Loan Calculator</span> ·
            <span onClick={() => navigate('/support')}>Help</span>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="overlay">
          <div className="modal elig-modal">
            <div className="elig-spinner"></div>
            <h3 className="elig-title">Checking Eligibility</h3>
            <p className="elig-sub">We're verifying your details…</p>
          </div>
        </div>
      )}
    </>
  );
}
